import { store } from "../redux/store";
import { mine } from "../api/modules/b2droppie.class";
import { updateUserData } from "../redux/slices/authSlice";
import { deleteCookie, getCookie, setCookie } from "./cookies.service";

export const syncUserData = async () => {
  const existingUser = getCookie("user");
  try {
    const resp = await mine();
    const updatedUser = resp?.data?.data;
    if (updatedUser) {
      const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      setCookie("user", JSON.stringify(updatedUser), expirationTime);
      store.dispatch(updateUserData(updatedUser));
      return updatedUser;
    }
  } catch (error) {
    if (existingUser) deleteCookie("user");
    console.error("Failed to sync user data:", error);
  }
  return null;
};
